module.exports = __webpack_public_path__ + "static/media/Cities_drop_off_image.5a98658f.png";